import { z } from "zod";

export const PMF_SURVEY_ANSWERS = [
  "very_disappointed",
  "somewhat_disappointed",
  "not_disappointed",
] as const;

export type PmfSurveyAnswer = (typeof PMF_SURVEY_ANSWERS)[number];

export const submitPmfSurveySchema = z
  .object({
    answer: z.enum(PMF_SURVEY_ANSWERS),
    explanation: z.string().trim().min(1).max(2000).optional(),
  })
  .strict();

export type SubmitPmfSurveyInput = z.infer<typeof submitPmfSurveySchema>;
